import { DownOutlined, KeyOutlined, LogoutOutlined, UserOutlined, } from "@ant-design/icons";
import { Button, Card, Col, Dropdown, Form, Image, Input, Modal, Row, } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Logo from "../../assets/images/Logo.svg";
import NotificationiconImage from "../../assets/images/notification-bell copy.d7924fe8ea9d53eacd66430de3359e33.svg";
import notfound from "../../assets/images/not_found.png";
import Notification from "../../assets/images/notification.svg";
import DeleteModal from "../../components/DeleteModal";
import { AuthContext } from "../../context/AuthContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import EditProfile from "../EditProfile";
import callApi from "../../constants/API/CallApi";
import { changePassword, getBank, updateBank } from "../../constants/API/API";
import useApi from "../../hooks/useApi";

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ name: sectionHeading, onPress, setToggle }) {
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [appSettingSelected, setAppSettingSelected] = useState();
  const [appSettingVisible, setAppSettingVisible] = useState(false);
  const [bankVisible, setBankVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { logout, userProfile, setUserProfile } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState([]);
  const navigate = useNavigate();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const notificationitems = [
    {
      label: (
        <div className="notification_top">
          <div className="notification-head">
            <h5>{lang("Notifications")}</h5>
          </div>
          <div className="notification-inner">
            {notification.map((item) => (
              <div
                key={item._id}
                className="single-notification single-notification-newmmm"
              >
                <div className="notification-img">
                  <img src={NotificationiconImage} />
                </div>
                <div
                  className="notification-cont"
                  onClick={() => (item?.use_for ? navigate(item?.use_for) : "")}
                >
                  <h4>{item.title}</h4>
                  <p>{item.message}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="viewAll_notification">
            <Button
              onClick={() => navigate("/notification")}
              className="btnStyle btn_primary"
            >
              {lang("View All")}
            </Button>
          </div>
        </div>
      ),
    },
  ];

  const items = [
    {
      label: lang("Edit Profile"),
      key: "1",
      icon: <UserOutlined />,
      danger: true,
    },
    {
      label: lang("Change Password"),
      key: "2",
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: lang("Bank Details"),
      key: "3",
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: lang("Logout"),
      key: "5",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  useEffect(() => {
    if (!isOpen) {
      document.body.classList.remove("edit-dropdown");
      return;
    }
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };

  const handleMenuClick = (e) => {
    setIsOpen(false);
    if (e.key === "1") {
      setProfileVisible(true);
    }
    if (e.key === "2") {
      setVisible(true);
    }
    if (e.key === "3") {
      setBankVisible(true);
    }
    if (e.key === "4") {
      setAppSettingVisible(true);
    }
    if (e.key === "5") {
      showDeleteConfirm();
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <>
      <Row gutter={[24, 0]} className="justify-content-between mx-0">
        <Col
          span={24}
          xs={24}
          md={24}
          lg={12}
          sm={24}
          className="SectionMain px-0"
        >
          <div className="toggale-headr">
            <div className="">
              <Button
                type="link"
                className="sidebar-toggler ps-0 d-none d-lg-block"
                onClick={() => setToggle()}
              >
                {toggler}
              </Button>
            </div>
            <div className="d-none d-lg-block">
              {sectionHeading}
              <p className="m-0">{lang(`Here is the information about all your ${sectionHeading}`)}</p>
            </div>
          </div>
          <div className="tabLogo d-sm-block d-lg-none">
            <img className="" width={50} src={Logo} />
          </div>
        </Col>
        <Col span={24} xs={24} sm={24} lg={12} className="header-control px-0">
          <Button
            type="link"
            className="sidebar-toggler ps-0"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>

          <div className="notificationDropdownMain">
            <div className="notification-header d-lg-block">
              <Dropdown
                menu={{ items: notificationitems }}
                trigger={["click"]}
                className="notification-box"
              >
                <Button>
                  <img src={Notification} />
                  <span className="active_notification"></span>
                </Button>
              </Dropdown>
            </div>
          </div>

          <div className="profileDropdownMain">
            <Dropdown
              open={isOpen}
              onOpenChange={(open) => setIsOpen(open)}
              className="edit-box"
              menu={menuProps}
              trigger={["click"]}
            >
              <Button className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open">
                <div className=" d-flex align-items-center gap-2">
                  <div className="userImg">
                    <Image
                      src={userProfile ? userProfile.profilePic : notfound}
                      preview={false}
                    />
                  </div>
                  <div className="d-none d-xl-block">
                    <div className="userName">
                      {userProfile ? userProfile?.name : "Administrator"}
                      <DownOutlined />
                    </div>
                  </div>
                </div>
              </Button>
            </Dropdown>
          </div>
        </Col>
      </Row>

      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to Logout?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => logout()}
        />
      )}

      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
          setUserProfile={setUserProfile}
        />
      )}

      {appSettingVisible && (
        <AppSetting
          show={appSettingVisible}
          hide={() => {
            setAppSettingVisible(false);
          }}
          data={appSettingSelected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {bankVisible && (
        <BankDetails
          show={bankVisible}
          hide={() => {
            setBankVisible(false);
          }}
          data={appSettingSelected}
          refresh={() => setRefresh((prev) => !prev)}
          setLoading={(x) => setLoading(x)}
        />
      )}

      {visible && (
        <ChangePassword
          show={visible}
          // handleCreate={handleCreate}
          setLoading={setLoading}
          hide={() => {
            setVisible(false);
          }}
        />
      )}
    </>
  );
}

export const AppSetting = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data]);

  return (
    <Modal
      width={1200}
      open={show}
      // title={`${data ? "Update App Setting" : ""}`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okText={lang("Ok")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Update App Setting</h4>
      <Form id="create" form={form} layout="vertical">
        <Row gutter={{ xs: [0, 16], md: [16, 0] }}>
          <Col span={24} md={12}>
            <Card title="Android Details">
              <Col span={24}>
                <Form.Item
                  label="App Store URL"
                  name="app_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the app store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter App Store URL" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Version"
                  name="android_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter Android Version" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Share Content"
                  name="android_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share Android Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>

          <Col span={24} md={12}>
            <Card title="IOS Details">
              <Col span={24} className="">
                <Form.Item
                  label="Play Store URL"
                  name="play_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the play store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Play Store URL" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Version"
                  name="ios_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter IOS Version" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Share Content"
                  name="ios_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share IOS Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, setLoading }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleCreate = (values) => {
    form
      .validateFields()
      .then((values) => {
        const payload = {};
        if (
          !form.getFieldValue("old_password") ||
          !form.getFieldValue("new_password")
        ) {
          return;
        }
        setLoading(true);
        payload.password = form.getFieldValue("new_password");
        payload.oldPassword = form.getFieldValue("old_password");
        callApi({
          callback: changePassword,
          payload: payload,
          onSuccess: (data) => {
            setLoading(false);
            ShowToast("Password changed successfully", Severty.SUCCESS);
            localStorage.clear();
            navigate("/login");
          },
          onError: (error) => {
            ShowToast("Old password is incorrect", Severty.ERROR);
            setLoading(false);
          },
        });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  return (
    <Modal
      open={show}
      // title="Change password"
      okText={lang("Ok")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      onOk={handleCreate}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okButtonProps={{
        form: "change-password",
        htmlType: "submit",
        // loading: loading,
      }}
    >
      <h4 className="modal_title_cls">{lang("Change Password")}</h4>
      <Form
        id="change-password"
        form={form}
        // onFinish={handleCreate}
        layout="vertical"
      >
        <Form.Item
          label="Old Password"
          name="old_password"
          normalize={(val) => val?.trimStart()}
          rules={[
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.reject("Please enter old password!");
                }
                if (value.length < 8) {
                  return Promise.reject(
                    "Password must be at least 8 characters"
                  );
                }
                if (value.length > 15) {
                  return Promise.reject(
                    "Password must be at most 15 characters"
                  );
                }
                if (!/[a-z]/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one lowercase letter."
                  );
                }
                if (!/[A-Z]/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one uppercase letter."
                  );
                }
                if (!/\d/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one number."
                  );
                }
                if (!/[^a-zA-Z0-9]/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one special character."
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input.Password placeholder="Enter your old password" />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="new_password"
          dependencies={["old_password"]}
          normalize={(val) => val?.trimStart()}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject("Please enter new password!");
                }
                if (value.length < 8) {
                  return Promise.reject(
                    "Password must be at least 8 characters"
                  );
                }
                if (value.length > 15) {
                  return Promise.reject(
                    "Password must be at most 15 characters"
                  );
                }
                if (!/[a-z]/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one lowercase letter."
                  );
                }
                if (!/[A-Z]/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one uppercase letter."
                  );
                }
                if (!/\d/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one number."
                  );
                }
                if (!/[^a-zA-Z0-9]/.test(value)) {
                  return Promise.reject(
                    "Password must contain at least one special character."
                  );
                }
                if (getFieldValue("old_password") === value) {
                  return Promise.reject(
                    "New password should be different from old password"
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>
        <Form.Item
          label="Confirm New Password"
          name="confirm_new_password"
          dependencies={["new_password"]}
          normalize={(val) => val?.trimStart()}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                const new_password = getFieldValue("new_password");
                if (!value) {
                  return Promise.reject("Please enter confirm password!");
                }
                if (value !== new_password) {
                  return Promise.reject("Password does not match");
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const BankDetails = ({ show, hide, setLoading }) => {
  const [form] = Form.useForm();

  useApi({
    callback: getBank,
    dependencies: [show],
    onSuccess: (res) => {
      form.setFieldsValue({ ...res });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleCreate = (values) => {
    form
      .validateFields()
      .then((values) => {
        const payload = { ...values };
        setLoading(true);
        callApi({
          callback: updateBank,
          payload: payload,
          onSuccess: (data) => {
            setLoading(false);
            ShowToast(data?.message, Severty.SUCCESS);
            hide();
          },
          onError: (error) => {
            ShowToast(error?.message, Severty.ERROR);
            setLoading(false);
          },
        });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <Modal
      open={show}
      // title="Change password"
      okText={lang("Ok")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      onOk={handleCreate}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      width={800}
      className="tab_modal"
      okButtonProps={{
        form: "change-password",
        htmlType: "submit",
        // loading: loading,
      }}
    >
      <h4 className="modal_title_cls">{lang("Add Bank Detail")}</h4>
      <Form
        id="change-password"
        form={form}
        // onFinish={handleCreate}
        layout="vertical"
      >
        <Row gutter={12}>
          <Col span={24} md={12}>
            <Form.Item
              label="Bank Name"
              name="bankName"
              normalize={(value) => value?.trimStart()}
              rules={[
                {
                  required: true,
                  message: "Please enter bank name!",
                },
              ]}
            >
              <Input placeholder="Enter Bank Name" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              label="Account Holder Name"
              name="accountHolderName"
              normalize={(value) => value?.trimStart()}
              rules={[
                {
                  required: true,
                  message: "Please enter account holder name!",
                },
              ]}
            >
              <Input placeholder="Enter Account Holder Name" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            {" "}
            <Form.Item
              label="Account Number"
              name="accountNumber"
              normalize={(value) => value?.trimStart()}
              rules={[
                {
                  required: true,
                  message: "Please enter account number!",
                },
              ]}
            >
              <Input placeholder="Enter Account Number" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            {" "}
            <Form.Item
              label="Swift Code"
              name="code"
              normalize={(value) => value?.trimStart()}
              rules={[
                {
                  required: true,
                  message: "Please enter swift code!",
                },
              ]}
            >
              <Input placeholder="Enter Swift Code" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            {" "}
            <Form.Item
              label="Branch Address"
              name="address"
              normalize={(value) => value?.trimStart()}
              rules={[
                {
                  required: true,
                  message: "Please enter branch address!",
                },
              ]}
            >
              <Input placeholder="Enter Bank's Branch Address" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Header;
